export const CRM_SELECTED_BOARD_STORAGE_KEY = 'selectedBoardId';
export const CRM_LEGACY_SELECTED_BOARD_STORAGE_KEYS = [
  'selectedBoardIdFindInvestors',
];

export const DEFAULT_BOARD_COLUMNS = [
  { column_id: 1, column_name: 'Research', investors: [], position: 1 },
  { column_id: 2, column_name: 'Contacted', investors: [], position: 2 },
  { column_id: 3, column_name: 'Committed', investors: [], position: 3 },
];
